/*
 * JuvaBun swipeable product card photos (snippets/jb-product-card.liquid with swipe: true, CSS in
 * snippets/jb-card-swipe-assets.liquid). Vanilla JS, deferred, event delegation only (no per-card setup), so cards
 * added later by collection filters or pagination work too.
 * - Only the first photo loads with the page. Other photos carry data-src / data-srcset and load when the shopper
 *   starts using that card (pointer over, touch, keyboard focus, arrow) - then the next photo - and the one after
 *   the slide that is shown, so a swipe never waits.
 * - Arrows: previous / next photo (disabled at the ends). Dots follow the scroll position.
 * - Tapping a photo opens the product (each slide is a link); a swipe or drag does not.
 */
(() => {
  if (window.__jbCardSwipe) return;
  window.__jbCardSwipe = true;
  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const parts = (box) => {
    const track = box.querySelector('[data-cs-track]');
    return { track, slides: track ? Array.from(track.children) : [] };
  };
  const load = (slide) => {
    const img = slide && slide.querySelector('img[data-src]');
    if (!img) return;
    if (img.dataset.srcset) img.srcset = img.dataset.srcset;
    img.src = img.dataset.src;
    img.removeAttribute('data-srcset');
    img.removeAttribute('data-src');
  };
  const index = (track) => Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
  const sync = (box) => {
    const { track, slides } = parts(box);
    if (!track) return;
    const i = Math.max(0, Math.min(slides.length - 1, index(track)));
    load(slides[i]);
    load(slides[i + 1]);
    box.querySelectorAll('.jb-cs__dots span').forEach((d, k) => d.classList.toggle('is-on', k === i));
    const prev = box.querySelector('[data-cs-prev]');
    const next = box.querySelector('[data-cs-next]');
    if (prev) prev.disabled = i === 0;
    if (next) next.disabled = i >= slides.length - 1;
  };
  const warm = (box) => {
    if (!box || box._jbWarm) return;
    box._jbWarm = true;
    const { track, slides } = parts(box);
    if (track) load(slides[index(track) + 1]);
  };
  const go = (box, step) => {
    const { track, slides } = parts(box);
    if (!track) return;
    const i = Math.max(0, Math.min(slides.length - 1, index(track) + step));
    load(slides[i]);
    load(slides[i + 1]);
    track.scrollTo({ left: i * track.clientWidth, behavior: reduceMotion() ? 'auto' : 'smooth' });
  };
  const boxOf = (t) => (t && t.closest ? t.closest('[data-jb-cs]') : null);

  ['pointerover', 'focusin'].forEach((ev) => document.addEventListener(ev, (e) => warm(boxOf(e.target)), { passive: true }));

  // Touch / pen / mouse: remember where the press started, so a swipe (or drag) is never taken as a tap
  let down = null;
  document.addEventListener('pointerdown', (e) => {
    const box = boxOf(e.target);
    if (!box) return;
    warm(box);
    down = { x: e.clientX, y: e.clientY, box };
  }, { passive: true });
  document.addEventListener('touchstart', (e) => warm(boxOf(e.target)), { passive: true });

  document.addEventListener('click', (e) => {
    const box = boxOf(e.target);
    if (!box) return;
    const arrow = e.target.closest('[data-cs-prev], [data-cs-next]');
    if (arrow) {
      e.preventDefault();
      e.stopPropagation();
      go(box, arrow.hasAttribute('data-cs-next') ? 1 : -1);
      return;
    }
    if (down && down.box === box && (Math.abs(e.clientX - down.x) > 10 || Math.abs(e.clientY - down.y) > 10)) {
      e.preventDefault(); // it was a swipe or drag, not a tap
    }
    down = null;
  }, true);

  // Scroll does not bubble: listen in the capture phase for every card track
  let raf = 0;
  let pending = null;
  document.addEventListener('scroll', (e) => {
    const t = e.target;
    if (!t || !t.matches || !t.matches('[data-cs-track]')) return;
    pending = t.closest('[data-jb-cs]');
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => { if (pending) sync(pending); });
  }, { capture: true, passive: true });
})();
